<div class="page-container">
    <div class="gradient-background"></div>
    <div class="page-content">
        <div class="header">
            <h1 class="font-bold header-title m-0">Get Premium at €29.99 instead of €49.99</h1>
            <br/>
            <p class="header-subtext font-light m-0">Use the code below during checkout to get <span class="font-bold">12 months of 1,000+ discounts</span> & SAVE up to <span class="font-bold">€500/year</span>!</p>
        </div>
        <div class="image-container">
            <img class="referral-image" src="old/friends/refer_a_friend2.webp" alt="Refer-a-Friend"/>
        </div>
        <div class="discount-code-section">
            <p class="recruiter mb-0">
                <span class="font-bold">{{friend()}}</span> has invited you
            </p>
            @if(code()){
                <input class="code-value" readonly [value]="code()"/>
            }
            <a class="code-cta premium-horizontal text-center" mat-flat-button routerLink="/checkout/yearly" [queryParams]="{ code: code() }">
                USE DISCOUNT CODE NOW
            </a>
            <p class="disclaimer">
                @if(auth.userSession()){
                    This code is saved in your account and can be used until {{expiry() | date: 'dd MMM, yyyy'}}.
                } @else {
                    Login or sign up to be able to use this code before it expires.
                }
                <br/>
                <a class="font-light" routerLink="/terms-and-conditions/social" fragment="baf-may22">Terms & Conditions apply</a>
            </p>
        </div>
        <mat-divider style="width: 100%;"></mat-divider>
        <div class="steps-container-sm">
            <h1 class="steps-title">
                <mat-icon paint="light">
                    help_outline
                </mat-icon>
                <span paint="primary" class="font-semibold">
                    How it works - Everybody wins!
                </span>
            </h1>
            <div class="steps steps-vertical">
                <h1 class="m-0 num font-bold" paint="primary">1</h1>
                <h4 class="m-0 instruction">
                    <span class="font-semibold" paint="primary">Download the cloudigo app</span>
                    <br/>
                    <span class="font-light" paint="light">Sign up or login to your account</span>
                </h4>
                <div class="filler">
                    <div></div>
                </div>
                <h1 class="m-0 num font-bold" paint="primary">2</h1>
                <h4 class="m-0 instruction" paint="light">
                    <span class="font-semibold" paint="primary">Subscribe to Premium Yearly</span>
                    <br/>
                    <span class="font-light" paint="light">Code above will be automatically applied during checkout</span>
                </h4>
                <div class="filler">
                    <div></div>
                </div>
                <h1 class="m-0 num final-step font-bold" paint="primary">3</h1>
                <h4 class="m-0 instruction final-step" paint="light">
                    <span class="font-semibold" paint="warn">Enjoy one whole year of savings</span>
                    <br/>
                    <span class="font-light" paint="light">From 350+ fashion shops, restaurants and more</span>
                </h4>
            </div>
        </div>
    </div>
</div>
<div class="steps-container-lg">
    <h1 class="steps-title-lg font-extrabold" paint="primary">How it works</h1>
    <div class="steps steps-horizontal">
        <div></div>
        <h1 class="m-0 num font-bold" paint="primary">1</h1>
        <div class="filler">
            <div></div>
        </div>
        <div class="filler">
            <div></div>
        </div>
        <h1 class="m-0 num font-bold" paint="primary">2</h1>
        <div class="filler">
            <div></div>
        </div>
        <div class="filler">
            <div></div>
        </div>
        <h1 class="m-0 num final-step font-bold" paint="primary">3</h1>
        <div></div>

        <h4 class="m-0 instruction">
            <span class="font-bold">Download the app</span>
            <br/>
            <small>Sign up or login to your cloudigo account</small>
        </h4>

        <h4 class="m-0 instruction">
            <span class="font-bold">Subscribe to Premium Yearly</span>
            <br/>
            <small>Code above will be automatically applied during checkout</small>
        </h4>

        <h4 class="m-0 instruction">
            <span class="font-bold">Enjoy & Save</span>
            <br/>
            <small>Enjoy one whole year of savings from 350+ fashion shops, restaurants and more</small>
        </h4>
    </div>
</div>